import { ISendMailFields } from "../../shared/interfaces"

export interface SendMailState {

    contactPanelIsOpen?: boolean
    targetFieldInternalNameOnAddContact?: string
    sendMailFields: ISendMailFields
    pickerToKey: number
    pickerCcKey: number
}


export const SET_SEND_MAIL_INITIAL_STATE = 'SET_SEND_MAIL_INITIAL_STATE'
interface SetInitialStateAction {
    type: typeof SET_SEND_MAIL_INITIAL_STATE
}

export const SET_NEXT_KEY_PICKER_COMPONENT_TO = 'SET_NEXT_KEY_PICKER_COMPONENT_TO'
interface SetNextKeyPickerComponentTo {
    type: typeof SET_NEXT_KEY_PICKER_COMPONENT_TO
}

export const SET_NEXT_KEY_PICKER_COMPONENT_CC = 'SET_NEXT_KEY_PICKER_COMPONENT_CC'
interface SetNextKeyPickerComponentCc {
    type: typeof SET_NEXT_KEY_PICKER_COMPONENT_CC
}

export const UPDATE_SEND_MAIL_STATE = 'UPDATE_SEND_MAIL_STATE'
interface UpdateStateAction {
    type: typeof UPDATE_SEND_MAIL_STATE
    payload: Partial<SendMailState>
}


export type SendMailActionTypes = SetInitialStateAction | SetNextKeyPickerComponentTo | SetNextKeyPickerComponentCc | UpdateStateAction